<div mat-dialog-content>

    <div class="flex flex-col flex-auto min-w-0">
        <div class="bg-card">
            <div class="flex flex-col min-w-0 ml-4">
                <ng-container *transloco="let t">
                </ng-container>
            </div>
            <br>
            <mat-card-content>
                <h5>CFDI Relacionados</h5>
                <h6>({{cliente.attributes.rfc}}){{cliente.attributes.nombre}}</h6>
                <h6>({{relacion.attributes.clave}}) {{relacion.attributes.descripcion }}</h6>

                <div class="grid grid-cols-1 lg:grid-cols-1 grid-flow-row gap-6 w-full mt-8 sm:mt-4">
                    <div class="row">

                        <div class="col-12">
                            <app-grid-component *ngIf="verGrid" [datos]="objetoGridConfiguration?.Data"
                                [columns]="objetoGridConfiguration.Columns"
                                [exportExcel]="objetoGridConfiguration.ExportExcel"
                                [columnHiding]="objetoGridConfiguration.ColumnHiding"
                                [Checkbox]="objetoGridConfiguration.Checkbox"
                                [Editing]="objetoGridConfiguration.Editing"
                                [Columnchooser]="objetoGridConfiguration.Columnchooser"
                                [searchPanel]="objetoGridConfiguration.SearchPanel"
                                [scroll]="objetoGridConfiguration.Scroll" (messageEvent)="receiveMessage($event)"
                                (datosevent)="datosMessage($event)" [toolbar]="objetoGridConfiguration.ToolBox"
                                (onRowUpdated)="Actualizar($event)" (modificar)='modificar($event.modificar.key)'
                                (eliminar)='eliminar($event.eliminar.key)' [descargarExcel]="descargarExcel"
                                [nombreReporte]="nombreReporte"></app-grid-component>
                        </div>
                    </div>
                </div>
            </mat-card-content>

        </div>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="close(0)">Cerrar</button>
    <button mat-flat-button color="accent" [disabled]="cfdisCheck.length <=0" cdkFocusInitial
        (click)="addRelacion(1);">Agregar</button>

</div>